module.exports = __webpack_public_path__ + "static/media/schedule.b15b517c.svg";